import dayjs from 'dayjs'
import React, { useEffect, useRef, useState } from 'react'
import MaterialInput from '../MaterialInput'
import { dateFormat } from '../../../consts'

import './DatePicker.css'

const getDatePart = (date, part) => {
  try {
    return dayjs(date).format(part)
  } catch {
    return ''
  }
}
const DatePicker = ({
  setSelectedDate,
  className = '',
  errorText,
  defaultDob = ''
}) => {
  const [day, setDay] = useState(
    defaultDob ? getDatePart(defaultDob, 'D') : null
  )
  const [month, setMonth] = useState(
    defaultDob ? getDatePart(defaultDob, 'M') : null
  )
  const [year, setYear] = useState(
    defaultDob ? getDatePart(defaultDob, 'YYYY') : null
  )

  const dateInput = useRef()
  const yearInput = useRef()

  const isEmpty = str => {
    if (!str || str.trim() === '') {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (
      !isEmpty(day) &&
      !isEmpty(month) &&
      !isEmpty(year) &&
      year.length === 4
    ) {
      setSelectedDate(dayjs(`${month}/${day}/${year}`).format(dateFormat))
    } else {
      setSelectedDate(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day, month, year])

  const handleMonthChange = event => {
    let mm = event.target.value
    if (mm >= 0 && mm <= 12) {
      setMonth(mm)
      if (mm.length >= 2) {
        dateInput.current.focus()
      }
    }
  }
  const handleDateChange = event => {
    let dd = event.target.value
    if (dd >= 0 && dd <= 31) {
      setDay(dd)
      if (dd.length >= 2) {
        yearInput.current.focus()
      }
    }
  }
  const handleYearChange = event => {
    let year = event.target.value
    if (year >= 0 && year.length <= 4) {
      setYear(year)
    }
  }
  return (
    <>
      <div
        className={
          errorText
            ? 'picker-container date-input error-date ' + className
            : 'picker-container date-input ' + className
        }
      >
        <MaterialInput
          type={'number'}
          label={'MM'}
          value={month}
          className='month-input'
          onChange={handleMonthChange}
        />
        <MaterialInput
          type={'number'}
          label={'DD'}
          ref={dateInput}
          value={day}
          className='day-input'
          onChange={handleDateChange}
        />
        <MaterialInput
          type={'number'}
          label={'YYYY'}
          ref={yearInput}
          className='year-input'
          value={year}
          onChange={handleYearChange}
        />
      </div>
      <div className='error error-date-input'>{errorText}</div>
    </>
  )
}

export default DatePicker
